
const ResourcesPage = () => (
  <div className="pt-24 px-6 max-w-7xl mx-auto">
    <h1 className="text-4xl font-bold mb-8">Resources</h1>
    <p>Find helpful resources for employee recognition and engagement.</p>
  </div>
);

export { Page }

function Page() {
  return <ResourcesPage />;
}
